module.exports = __webpack_public_path__ + "img/roche.092e0cab.gif";